module.exports = __webpack_public_path__ + "img/v-outline-filled-pink.0e7ffe07.svg";